import { render, staticRenderFns } from "./AppCreditsSection.vue?vue&type=template&id=669f82c3&"
import script from "./AppCreditsSection.vue?vue&type=script&lang=js&"
export * from "./AppCreditsSection.vue?vue&type=script&lang=js&"
import style0 from "./AppCreditsSection.vue?vue&type=style&index=0&id=669f82c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports